const maintenanceEquipments = {
  toastr: 'Equipos actualizados',
  toastr1: 'Equipos ENVIADOS a mantenimiento con éxito',
  toastr2: 'Equipos DEVUELTOS a mantenimiento con éxito',
};

export default maintenanceEquipments;
